if (!customElements.get('related-collections-slider')) {
  class RelatedCollectionsSlider extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      scrollbar: '.swiper-scrollbar',
    };
    settings = {
      slidesPerView: 1.06,
      spaceBetween: 16,
      scrollbar: {
        el: this.selectors.scrollbar,
        draggable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
      },
    };
    slider = undefined;

    /**
     * Constructor.
     */
    constructor() {
      super();
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.init();
    }

    /**
     * Init.
     *
     * @returns {Void}
     */
    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
    }
  }
  customElements.define('related-collections-slider', RelatedCollectionsSlider);
}
